export const PUBLIC_AUTH_SERVER_URL = process.env.NEXT_PUBLIC_AUTH_SERVER_URL || '';
export const PUBLIC_CLIENT_URL = process.env.NEXT_PUBLIC_CLIENT_URL || '';
export const PUBLIC_RONIN_CONFIG = process.env.NEXT_PUBLIC_RONIN_CONFIG || '';
export const PUBLIC_FB_APPID = process.env.NEXT_PUBLIC_FB_APPID || '';
export const PUBLIC_GOOGLE_CLIENTID = process.env.NEXT_PUBLIC_GOOGLE_CLIENTID || '';
export const PUBLIC_WHITELIST_REDIRECT_URIS = process.env.NEXT_PUBLIC_WHITELIST_REDIRECT_URIS || '';
export const PUBLIC_WHITELIST_2FA_URIS = process.env.NEXT_PUBLIC_WHITELIST_2FA_URIS || '';
export const PUBLIC_OAUTH2_REQUEST_AUDIENCE = process.env.NEXT_PUBLIC_OAUTH2_REQUEST_AUDIENCE || '';
export const PUBLIC_CLIENT_ID = process.env.NEXT_PUBLIC_CLIENT_ID || '';
export const PUBLIC_TRACKING_API_KEY = process.env.NEXT_PUBLIC_TRACKING_API_KEY || '';
export const PUBLIC_TRACKING_API_URL = process.env.NEXT_PUBLIC_TRACKING_API_URL || 'https://x.skymavis.com/track';
export const PUBLIC_CAPTCHA_API_KEY = process.env.NEXT_PUBLIC_CAPTCHA_API_KEY || '';
export const PUBLIC_CAPTCHA_API_URL = process.env.NEXT_PUBLIC_CAPTCHA_API_URL || '';
//# sourceMappingURL=envs.js.map